/**
 * Settings API Endpoints
 * All operations are admin-only.
 */
export const SETTINGS_ENDPOINTS = {
  /**
   * Get all settings.
   * @method GET
   * @endpoint /settings
   */
  SETTINGS: "/settings",

  /**
   * Get a single setting by key.
   * @method GET
   * @endpoint /settings/{key}
   */
  SETTING_BY_KEY: (key: string) => `/settings/${encodeURIComponent(key)}`,

  /**
   * Upsert (create or update) a setting by key.
   * @method PUT
   * @endpoint /settings/{key}
   */
  UPSERT_SETTING: (key: string) => `/settings/${encodeURIComponent(key)}`,

  /**
   * Delete a setting by key.
   * @method DELETE
   * @endpoint /settings/{key}
   */
  DELETE_SETTING: (key: string) => `/settings/${encodeURIComponent(key)}`,
} as const;
